import { sendAlert } from '../controllers/noti_controller';

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      const error = data || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}

export default function callApi(url, method, body) {
  return fetch(window.$_spring.context_path + url, {
    method,
    credentials: 'include',
    headers: { ...window.$_csrf, 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
    .then(handleResponse)
    .catch((error) => {
      if (error instanceof TypeError || error instanceof SyntaxError) {
        sendAlert('네트워크 연결에 문제가 있습니다. 반복된다면 관리자에게 문의해주세요');
      }
      return Promise.reject(error);
    });
}

export function callApiWithoutBody(url, method) {
  return fetch(window.$_spring.context_path + url, {
    method,
    credentials: 'include',
    headers: { ...window.$_csrf, 'Content-Type': 'application/json' },
  }).then(handleResponse);
}
